import React from 'react';
import Hero from '../components/home/Hero';
import AboutSection from '../components/home/AboutSection';
import OurCraft from '../components/home/OurCraft';
import WhyChooseUs from '../components/home/WhyChooseUs';
import BuildTogether from '../components/home/BuildTogether';

const Home = () => {
  return (
    <main className="bg-[#fdfcfb]">
      <Hero />
      <AboutSection />
      <OurCraft />
      <WhyChooseUs />
      <BuildTogether />
    </main>
  );
};

export default Home;